import { Injectable } from '@angular/core';
import { ExperimentStatusDictionary } from '../../core-data-model/ExperimentAccess.model';
import { ExperimentAccessStatusServer } from './ExperimentAccess.serverinterface';

@Injectable({ providedIn: 'root' })
export class ExperimentAccessTransformers {
    transformServerToClient(
        serverExperimentStatusDataList: ExperimentAccessStatusServer[]
    ): ExperimentStatusDictionary {
        const expStatusDict: ExperimentStatusDictionary = {};

        if (serverExperimentStatusDataList) {
            serverExperimentStatusDataList.forEach(
                (exp) =>
                    (expStatusDict[exp.experimentName] = exp.isAccessAllowed)
            );
        }
        return expStatusDict;
    }
}
